const locationIcons = () => ({
  'HOME': '/icons/home.png',
  'VIRTUAL': '/icons/virtual.png',
  'OTHER_MOBILE': '/icons/mobile.png',
  'PARTNER': '/icons/facility.png',
});

const SessionTypeLocationIcon = props => {
  const {sessionType} = props;
  const iconSrc = locationIcons()[sessionType.location_type];
  if (!iconSrc) return <></>;
  return (
    <img 
      alt={sessionType.location_type}
      src={iconSrc}
      style={{
        maxWidth: '50px',
        maxHeight: '50px',
      }}
    />
  );
};

export default SessionTypeLocationIcon;